import React from 'react';
const stats = [{
  value: '+500',
  label: 'Lashistas confían'
}, {
  value: '12',
  label: 'Tomos listos'
}, {
  value: '5',
  label: 'Bonos incluidos'
}, {
  value: '4.9/5',
  label: 'Calificación ⭐'
}];
export function Stats() {
  return <section aria-label="Resultados reales" className="bg-ink-2 border-y border-white/5" data-id="element-137" data-mp="2ixfn580l91wq">
      <div className="mx-auto max-w-5xl px-5 py-10 pt-[0px] pb-[0px]" data-id="element-138" data-mp="2nvh2bhuw8h2x">
        
        <dl className="grid grid-cols-2 gap-6 sm:grid-cols-4 pt-[8px] pb-[7px]" data-id="element-139" data-mp="29731fch1f2p0">
          {stats.map(s => <div key={s.label} className="text-center" data-id="element-140" data-mp="2dzw6k1gf4d1m">
              <dt className="font-display text-4xl font-black text-white sm:text-5xl" data-id="element-141" data-mp="2e0p2e7du9i4z">{s.value}</dt>
              <dd className="mt-1 text-sm font-medium text-white/60" data-id="element-142" data-mp="256k79bro9kjn">{s.label}</dd>
            </div>)}
        </dl>
      </div>
    </section>;
}